import { Component, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { Subscription, tap } from "rxjs";
import { PreferencesService } from "../services/preferences.service";

@Component({
  selector: "app-units-chooser",
  template: `
    <span [formGroup]="unitsChoiceForm">
    <label i18n="@@SelectUnits">Select Units</label> &nbsp;
    <select formControlName="unitsChoice">
        <option *ngFor="let option of unitChoices" [value]="option">
          {{ option }}
        </option>
      </select>
</span>
  `,
  styles: [],
})
export class UnitsChooserComponent implements OnInit, OnDestroy {
  unitChoices: string[] = ["L/ha", "US gal/ac","US pt/ac"];
  unitsChoiceForm: FormGroup;
  formSub: Subscription;
  constructor(
    private preferencesService: PreferencesService,
    private fb: FormBuilder
  ) {
    
    this.unitsChoiceForm = this.fb.group({
      unitsChoice: [this.preferencesService.unitsChoice$.getValue()],
    });

    this.formSub = this.unitsChoiceForm.valueChanges
      .pipe(
        tap((values) => {
          console.log("Changing Units to ", values.unitsChoice);
          this.preferencesService.unitsChoice = values.unitsChoice;
        })
      )
      .subscribe();
  }
  ngOnDestroy(): void {
        this.formSub.unsubscribe();
  }
  ngOnInit(): void {}
}
